export const Running = 'Running';
export const Closed = 'Closed';